<template>
    <app-layout class="insurance-plans">
        <common-content-spacer height="medium">
            <common-content-spacer height="small">
                <common-breadcrumbs :breadcrumbs="pageBreadcrumbs"></common-breadcrumbs>

                <common-page-header :heading="pageTitle"></common-page-header>
            </common-content-spacer>

            <common-page-plain>
                <common-content-spacer height="medium">
                    <common-page-header :heading="pageSubTitle">
                        <template #right>
                            <div class="insurance-plans__back-button">
                                <common-buttons>
                                    <common-icon name="arrow-left-blue" size="tiny"></common-icon>
                                    <common-button
                                        :label="$t('pages.practice.insurance.buttons.back_to_profile')"
                                        type="tertiary"
                                        size="tiny"
                                        @click="$router.go(-1)"
                                    ></common-button>
                                </common-buttons>
                            </div>
                        </template>
                    </common-page-header>
                    <alphabet-table
                        ref="insurancePlansTable"
                        :prefillValues="prefillValues"
                        :alhpabetObject="alhpabetObject"
                        :showTopSaveButton="true"
                        :itemsOnTop="itemsOnTop"
                        @alphabet-selection-save="saveChanges"
                    ></alphabet-table>
                </common-content-spacer>
            </common-page-plain>
        </common-content-spacer>
    </app-layout>
</template>

<script>
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import PageWithElementsMixin from 'mixins/PageWithElementsMixin'
    import AppLayout from 'components/layouts/AppLayout'
    import AlphabetTable from 'components/page-elements/alphabet-table/AlphabetTable'
    import InsurancePlansAPI from 'api/InsurancePlanGroupsAPI'
    import PracticesAPI from 'api/PracticesAPI'

    export default {
        mixins: [PageWithTitleMixin, PageWithElementsMixin],

        components: {
            AppLayout,
            AlphabetTable,
        },

        data() {
            return {
                alhpabetObject: {},
                itemsOnTop: [],
                isLoading: false,
            }
        },

        computed: {
            pageTitle() {
                return this.$t('pages.practice.insurance.titles.practice_members', {
                    practiceName: this.$auth.getPractice().name,
                })
            },

            prefillValues() {
                return this.$auth.getPractice().insurancePlans
            },

            pageSubTitle() {
                return this.$t('pages.practice.insurance.titles.insurance_plans_accepted')
            },

            pageBreadcrumbs() {
                return [
                    {
                        label: this.$t('pages.practice.insurance.breadcrumbs.practice'),
                        route: { name: 'practice.members' },
                    },
                    {
                        label: this.$t('pages.practice.insurance.breadcrumbs.practice_profile'),
                        route: { name: 'practice.profile' },
                    },
                    {
                        label: this.$t('pages.practice.insurance.breadcrumbs.insurance_plans'),
                    },
                ]
            },
        },

        methods: {
            getInsurancePlans() {
                InsurancePlansAPI.getListTransformByLetter().then((val) => {
                    this.alhpabetObject = val.alhpabetObject
                    this.itemsOnTop = val.itemsOnTop
                })
            },

            saveChanges(value) {
                this.$refs.insurancePlansTable.isSending = true
                PracticesAPI.update(this.$auth.getPractice().id, {
                    insurancePlanIds: value,
                }).then(() => {
                    if (this.$auth.isPracticeAncillary()) {
                        this.$router.push({ name: 'practice.profile-ancillary' })
                    } else {
                        this.$router.push({ name: 'practice.profile' })
                    }
                    this.$refs.insurancePlansTable.isSending = false
                })
            },
        },

        created() {
            this.getInsurancePlans()
            this.selectedItems = this.prefillValues
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_functions.scss';
    @import 'styles/setup/_mixins.scss';

    .insurance-plans {
        &__back-button {
            .icon {
                margin-top: 10px;
            }
        }

        @include breakpoint(smartphone-large) {
            ::v-deep .page-header__heading {
                flex-direction: column;
                align-items: flex-start;
            }

            ::v-deep .page-header__right {
                position: static;
                transform: none;
                margin-top: 8px;
            }

            &__back-button ::v-deep .buttons {
                flex-wrap: nowrap;
                justify-content: flex-start;

                > * {
                    min-width: 0;
                    margin-bottom: 0;
                }

                > *:not(:first-child) {
                    margin-left: 8px;
                }

                .icon {
                    margin-top: 0;
                }
            }
        }
    }
</style>
